import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent, onMounted, ref } from 'vue'
import { useIntersectionObserver } from '@vueuse/core'
import { useRoute } from 'vue-router/composables'


export default /*#__PURE__*/_defineComponent({
  __name: 'TopResumePreview',
  setup(__props) {

/**
 * トップの「履歴書完成イメージ」帯。template は静的トップにもそのまま展開される
 * （scripts/extract-top-static.js）ので、バインディングを持たない素の HTML に保つ。
 *
 * 見開きの記入例（プレビュー本体・記入例データ・書式 CSS）は重いので、
 * 枠が画面に近づいてから遅延チャンクで読む。
 *
 * 別ページのヘッダータブから /#resume-complete-image で来たときは、Vue マウントで
 * DOM が差し替わり初期スクロールがずれるため、マウント後にもう一度アンカーへ寄せる。
 */
const TopResumeSampleSpread = defineAsyncComponent(
  () => import('@/components/top/TopResumeSampleSpread.vue')
)

const route = useRoute()

const spreadRef = ref<HTMLElement | null>(null)
const isSpreadNear = ref(false)
const { stop: stopObservingSpread } = useIntersectionObserver(
  spreadRef,
  ([entry]) => {
    if (!entry?.isIntersecting) return
    isSpreadNear.value = true
    stopObservingSpread()
  },
  { rootMargin: '400px 0px' }
)

onMounted(() => {
  if (route.hash !== '#resume-complete-image') return
  document.getElementById('resume-complete-image')?.scrollIntoView()
})

return { __sfc: true,TopResumeSampleSpread, route, spreadRef, isSpreadNear, stopObservingSpread }
}

})